
import { environment } from "../environments/environment";
import { globalState } from "./globalstate";
import { ObjI as ObjectI } from "../Core/@types";
import { ThunkDispatch } from "redux-thunk";
import { Action } from "redux";
import { DIredux } from "../Core";
import { APP_SOURCE_NAME, APP_TARGET_NAME } from "../Constant";
import { isAdminLoggedIn } from "../Components/Panel/Panel/index";
import { getDecryptedItem } from './secureSession';

const message = `Sorry, the request was unsuccessful. Please try again later.`;
let logoutFlag = true;

type ReduxI = ThunkDispatch<any, unknown, Action<string>>;

function getAdditionalParams(StateProps: any) {
  const marketplace =
    globalState.get(StateProps)("target_marketplace") ?? "all";
  const params: any = {
    marketplace: marketplace,
    shop_id: globalState.get(StateProps)("target_shop_id"),
  };
  if (globalState.get(StateProps)("target_warehouse_id")) {
    params["warehouse_id"] = globalState.get(StateProps)("target_warehouse_id");
  }

  return {
    target_marketplace: btoa(JSON.stringify(params)),
  };
}

export function prepareheaders(StateProps: DIredux): {
  Authorization: string;
  appTag: string;
  appCode: string;
  "Ced-Source-Id": string;
  "Ced-Source-Name": string;
  "Ced-Target-Id": string;
  "Ced-Target-Name": string;
} {
  const token = globalState.getBearerToken(StateProps)(false);
  return {
    Authorization: "Bearer " + token, //in future remove false if user_id instead of user
    appCode: btoa(JSON.stringify(environment.appCode)),
    appTag: environment.appTag,
    "Ced-Source-Id":
      StateProps.current?.source?._id ??
      globalState.get(StateProps)("source_id") ??
      "",
    "Ced-Source-Name":
      APP_SOURCE_NAME ??
      StateProps.current?.source?.marketplace ??
      globalState.get(StateProps)("source_name") ??
      APP_SOURCE_NAME ??
      "",
    "Ced-Target-Id":
      StateProps.current?.target?._id ??
      globalState.get(StateProps)("target_id") ??
      "",
    "Ced-Target-Name":
      StateProps.current?.target?.marketplace ??
      globalState.get(StateProps)("target_name") ??
      APP_TARGET_NAME ??
      "",
  };
}

const GET =
  (dispatch: ReduxI, StateProps: DIredux) =>
    (endpoint: string, params?: any, fullUrl = false): Promise<any> => {
      let paramsString = "";

      if (!params) params = getAdditionalParams(StateProps);

      if (endpoint.search("\\?") >= 0) paramsString += "&";
      else paramsString += "?";

      for (let i = 0; i < Object.keys(params).length; i++) {
        const end = i < Object.keys(params).length - 1 ? "&" : "";
        paramsString +=
          Object.keys(params)[i] +
          "=" +
          encodeURIComponent(params[Object.keys(params)[i]]) +
          end;
      }

      let url = environment.API_ENDPOINT + endpoint;
      if (fullUrl) {
        url = endpoint;
      }
      const { "Ced-Target-Id": _, ...rest } = prepareheaders(StateProps);
      const updatedHeaders = { ...rest, "Ced-Target-Id": "" };
      const headers: any =
        endpoint === "connector/frontend/getStepsDetails"
          ? { ...updatedHeaders }
          : prepareheaders(StateProps);
      return fetch(url + paramsString, {
        method: "GET",
        headers: headers,
      })
        .then((res) => res.json())
        .then((e) => {
          validateResponse(e, dispatch, StateProps);
          return responseModifier(e);
        })
        .catch((e) => {
          return { success: false, message: message, code: e };
        });
    };

const POST =
  (dispatch: ReduxI, StateProps: DIredux) =>
    (endpoint: string, data?: ObjectI, fullUrl = false): Promise<any> => {
      let url = environment.API_ENDPOINT + endpoint;
      if (fullUrl) {
        url = endpoint;
      }
      return fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          ...prepareheaders(StateProps),
        },
        body: JSON.stringify({
          ...data,
        }),
      })
        .then((res) => res.json())
        .then((e) => {
          validateResponse(e, dispatch, StateProps);
          return responseModifier(e);
        })
        .catch((e) => {
          return { success: false, message: message, code: e };
        });
    };

export const __customFetch = (
  endPoint: string,
  data: any,
  method = "GET"
): Promise<any> => {
  let updatedEndpoint = environment.API_ENDPOINT + endPoint;
  if (method === "GET") {
    let paramsString = "?";

    for (let i = 0; i < Object.keys(data).length; i++) {
      const end = i < Object.keys(data).length - 1 ? "&" : "";
      paramsString +=
        Object.keys(data)[i] +
        "=" +
        encodeURIComponent(data[Object.keys(data)[i]]) +
        end;
    }
    updatedEndpoint += paramsString;
  }
  return fetch(updatedEndpoint, {
    method: method === "GET" ? "GET" : "POST",

    ...(method === "POST" && {
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),
  })
    .then((res) => res.json())
    .then((e) => {
      return responseModifier(e);
    })
    .catch((e) => {
      return { success: false, message: message, code: e };
    });
};
const DELETE =
  (dispatch: ReduxI, StateProps: DIredux) =>
    (endpoint: string, data?: ObjectI, fullUrl = false): Promise<any> => {
      let url = environment.API_ENDPOINT + endpoint;
      if (fullUrl) {
        url = endpoint;
      }
      return fetch(url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          ...prepareheaders(StateProps),
        },
        body: JSON.stringify({
          ...data,
        }),
      })
        .then((res) => res.json())
        .then((e) => {
          validateResponse(e, dispatch, StateProps);
          return responseModifier(e);
        })
        .catch((e) => {
          return { success: false, message: message, code: e };
        });
    };

const PUT =
  (dispatch: ReduxI, StateProps: DIredux) =>
    (endpoint: string, data?: ObjectI, fullUrl = false): Promise<any> => {
      let url = environment.API_ENDPOINT + endpoint;
      if (fullUrl) {
        url = endpoint;
      }
      return fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          ...prepareheaders(StateProps),
        },
        body: JSON.stringify({
          ...data,
        }),
      })
        .then((res) => res.json())
        .then((e) => {
          validateResponse(e, dispatch, StateProps);
          return responseModifier(e);
        })
        .catch((e) => {
          return { success: false, message: message, code: e };
        });
    };

const PATCH =
  (dispatch: ReduxI, StateProps: DIredux) =>
    (endpoint: string, data?: ObjectI, fullUrl = false): Promise<any> => {
      let url = environment.API_ENDPOINT + endpoint;
      if (fullUrl) {
        url = endpoint;
      }
      return fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          ...prepareheaders(StateProps),
        },
        body: JSON.stringify({
          ...data,
        }),
      })
        .then((res) => res.json())
        .then((e) => {
          validateResponse(e, dispatch, StateProps);
          return responseModifier(e);
        })
        .catch((e) => {
          return { success: false, message: message, code: e };
        });
    };
const validateResponse = (e: any, dispatch: ReduxI, StateProps: DIredux) => {
  // Check for admin context

  if (
    e.code === "token_expired" ||
    e.code === "invalid_token" ||
    e.code === "future_token" ||
    e.code === "token_decode_error" ||
    e.code === "token_user_not_found"
  ) {
    handleReAutorizationProcess(StateProps, dispatch);
    sessionStorage.clear();
    if (logoutFlag) {
      dispatch({
        type: 'LOGIN_STATUS',
        state: {
          data: e,
          status: 'LOGOUT',
        },
      });
    }
  }
};

function paramsToObject(entries: any) {
  const result: any = {}
  for (const [key, value] of entries) {
    result[key] = value;
  }
  return result;
}

const handleReAutorizationProcess = async (StateProps: DIredux, dispatch: ReduxI) => {

  let queryParams: any = globalState.get(StateProps)('queryParams', true) ?? getDecryptedItem("queryParams") ?? "";

  if (!queryParams) {
    const params: any = new URLSearchParams(location.search);
    const entries = params.entries();
    queryParams = paramsToObject(entries);
  }
  const get = GET(dispatch, StateProps); // use the curried GET
  const multiAccountUserCheck = await get("shopifyhome/migration/isUserExistsInMulti", queryParams);

  if (multiAccountUserCheck?.success) {
    const data = multiAccountUserCheck.data;

    const user_details: any = {
      user_id: data.user_id,
      host: globalState.get(StateProps)("host"),
      shop: globalState.get(StateProps)("shop"),
      source_shop_id: data.source_shop_id,
      target_shop_id: data.target_shop_id,
      username: data.username,
      token: data.token
    };

    globalState.set(StateProps)('auth_token', user_details.token, true);
    globalState.set(StateProps)('host', user_details.host, true);
    globalState.set(StateProps)('shop', user_details.shop, true);
    globalState.set(StateProps)('source_id', user_details.source_shop_id, true);

    if (globalState.get(StateProps)('target_id', true) == null) {
      globalState.set(StateProps)('target_id', user_details.target_shop_id, true);
    }

    globalState.set(StateProps)('target', 'amazon', true);
    globalState.set(StateProps)('source', 'shopify', true);
    globalState.set(StateProps)('all_shops', JSON.stringify({
      [user_details.shop]: user_details
    }));

    logoutFlag = false;
    return true;
  }

  logoutFlag = true;
  return false;
};

export function responseModifier(res: ObjectI): ObjectI {
  if (!res["success"] || res["errorFlag"] !== undefined) {
    res["success"] = false;
    if (!res["message"] && res["msg"]) {
      res["message"] = res["msg"];
    }
  }
  if (
    res.code === 'token_expired' ||
    res.code === 'invalid_token' ||
    res.code === 'future_token' ||
    res.code === 'token_decode_error'
  ) {
    res['message'] = 'Server Error! Try Again!';
  }
  return res;
}

const requests = {
  GET: GET,
  POST: POST,
  DELETE: DELETE,
  PUT: PUT,
  PATCH: PATCH,
};

export default requests;

export { GET, POST, DELETE, PUT, PATCH };
